var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDataCountry(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.31055 16.0688C3.31055 14.9643 4.20598 14.0688 5.31055 14.0688H6.27606C7.38063 14.0688 8.27606 14.9643 8.27606 16.0688V20.6895H3.31055V16.0688Z",
    fill: "#FF6401"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.10352 12.7585C9.10352 11.654 9.99895 10.7585 11.1035 10.7585H12.069C13.1736 10.7585 14.069 11.654 14.069 12.7585V20.6896H9.10352V12.7585Z",
    fill: "#DEE2E5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8965 6.13794C14.8965 5.03337 15.7919 4.13794 16.8965 4.13794H17.862C18.9666 4.13794 19.862 5.03337 19.862 6.13794V20.6897H14.8965V6.13794Z",
    fill: "#DEE2E5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDataCountry);
export default __webpack_public_path__ + "static/media/data_country.b603baaf0d9cd6b34b393d63401b53e5.svg";
export { ForwardRef as ReactComponent };